import {
    getPortfolioEventByUid,
    GetPortfolioEventByUidApiResponseSchema,
} from './get-portfolio-event-by-uid';

export {
    GetPortfolioEventByUidApiResponseSchema,
};

export const PortfolioEventPageActions = {
    getPortfolioEventByUid,
};
